<template>
    
  <div class="main">
    <section class="section">
      <h2 class="page-title">Een hartstilstand?</h2>
      <h1 class="animate__animated animate__zoomIn animate__delay-1s">HELP!</h1>
      <p class="text-white">
        Elke dag krijgen bijna dertig mensen in België een hartstilstand buiten het ziekenhuis, zo meldt de Belgische Cardiologische Liga. Amper één tot drie van hen overleven. Snelle hulp kan nochtans veel meer mensen redden.
      </p>
  
    </section>
  

  <section class="click-section">
    

    <Clickheart class="click-heart" @click="yellowTransition"/>

  
    <div id="circle-yellow"></div>
  


  </section>

<div class="lottie-wrapper">
  <div class="lottie-1">
    <Vue3Lottie animationLink="https://lottie.host/fe5a26be-e0d5-4932-9477-fcb47925c49a/qiXz0z6KqW.json"/>
  </div>
</div>


  
  </div>
  </template>
  
  
  
  <script>
  import Clickheart from "./click-heart.vue";
  export default {
    name: 'home-blue',
    components: {
      Clickheart
    },
    methods:{
      async yellowTransition() {
        let cirlce = document.getElementById("circle-yellow");
        cirlce.style.opacity=1;
        cirlce.style.transform="scale(55,55)";
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.$router.push({ path: '/112' });
    },
    onClick() {
      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'Calculator',
        action: 'click',
        label: 'Home page SIP calculator',
        value: 5000,
        noninteraction: false, // Optional
      });
    }

    },
    mounted() {
    this.$gtm.trackView('Een hartstilstand?', '/');
  }
    }
  </script>
  
  <style scoped>
  .main{
    background-color: var(--color-blue);
  }
  .section{
    max-width: 815px;
  }
  h2{
    color: var(--color-white);
    font-weight: 700;
    font-size: 25px;
    margin-bottom: 0px;
  }
  
  .text-white{
    color: var(--color-white);  
    animation: appear 1s ease-in-out 2s forwards;
    font-weight: 600;
    z-index: 5;
  }
  .lottie-1{
    z-index: 1;
    /* bottom: -5px; */
    /* margin-left: -13%; */
    min-width: 350px;
    pointer-events: none; 
    /* transform: scale(1.4); */
  }
  #circle-yellow{
  position: absolute;
  opacity: 0;
  z-index: 6;
  
  bottom: 1%;
  background-color: var(--color-yellow);
  border-radius: 50%;

  width: 50px;
  height: 50px;

  left: 50%;
  transform: translateX(-50%);

  transform-origin: center;

  transition: transform 0.9s ease-in;
  
  }
  @media (min-width: 1000px){
    .page-title{
      font-size: 3.125rem;
      z-index: 6;
    }

  #circle-yellow{
  position: absolute;
  opacity: 0;
  z-index: 20;
  
  bottom: 35%;
  background-color: var(--color-yellow);
  border-radius: 50%;

  width: 50px;
  height: 50px;

  left: 20%;
  transform: translateX(-25%);

  
  }
}
.lottie-wrapper{
  position: absolute;
  overflow: hidden;
  bottom: -10px;
  left: 0;
  right: 0;
  /* margin-left: auto; */
  margin-right: auto;
  
  max-width: 850px;

  transform: translateX(-9%);
}
  
  .page-title{
    animation: appear 1s ease-in-out forwards;
  }

  

  
  
  </style>
  